import { render, staticRenderFns } from "./take.vue?vue&type=template&id=489f59ea&scoped=true&"
import script from "./take.vue?vue&type=script&lang=js&"
export * from "./take.vue?vue&type=script&lang=js&"
import style0 from "./take.vue?vue&type=style&index=0&id=489f59ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489f59ea",
  null
  
)

export default component.exports